import { NavLink, useLocation } from "react-router-dom";

export const Footer = () => {
    const location = useLocation();
    const hideHeaderForBookingConfirm = "/booking-confirm";
    const hideHeaderForAdmin = "admin";
    if (hideHeaderForBookingConfirm.endsWith(location.pathname)) {
        return <></>;
    }

    if (location.pathname.replace("/", "").startsWith(hideHeaderForAdmin)) {
        return <></>;
    }

    const footerLinkClasses = ({ isActive }: { isActive: boolean }) =>
        `hover:text-white ${isActive ? "text-white font-semibold" : "text-gray-300"
        }`;

    return (
        <footer className="bg-[#2A2E3D] text-gray-300">
            <div className="w-full mx-auto px-10">
                {/* Top Row */}
                <div className="flex flex-col md:flex-row items-center justify-between border-b border-gray-600 py-8">
                    {/* Navigation Links */}
                    <ul className="flex flex-wrap items-center justify-center md:justify-start gap-10 text-sm font-medium">
                        <li>
                            <NavLink to="/" className={footerLinkClasses}>Home</NavLink>
                        </li>
                        <li>
                            <NavLink to="/about-us" className={footerLinkClasses}>About Us</NavLink>
                        </li>
                        <li>
                            <NavLink to="/features" className={footerLinkClasses}>Features</NavLink>
                        </li>
                        <li>
                            <NavLink to="/faq" className={footerLinkClasses}>FAQ</NavLink>
                        </li>
                        <li>
                            <NavLink to="/contact-us" className={footerLinkClasses}>Contact</NavLink>
                        </li>
                    </ul>

                    {/* Payment Icons */}
                    <div className="flex items-center gap-4 mt-4 md:mt-0">
                        <img
                            src="/images/mastercard-logo.png"
                            alt="Mastercard"
                            className="h-[35px]"
                        />
                        <img
                            src="/images/visa-logo.png"
                            alt="Visa"
                            className="h-[35px]"
                        />
                        <img
                            src="/images/paypal-logo.png"
                            alt="PayPal"
                            className="h-[35px]"
                        />
                    </div>
                </div>

                {/* Bottom Row */}
                <div className="flex flex-col md:flex-row items-center justify-between text-sm py-8 text-white font-medium">
                    <p>Mon - Fri 09:00am - 5:00pm</p>
                    <p className="mt-2 md:mt-0">
                        Terms & Conditions | Privacy | © {new Date().getFullYear()}
                    </p>
                </div>
            </div>
        </footer>
    )
}
